// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"D0-z","subtitle":"E0-z","wrapper":"F0-z","leftArrow":"G0-z","rightArrow":"H0-z"};